import React from "react";
import ProductOnboardingFlow from "components/shared/ProductOnboarding/Flow";
import {
  getTaxRefundAdvanceApplicationStatus,
  getUserProfile,
} from "store/api/apiSlice";
import { ProductName } from "types/general";
import { OnboardingTaskName } from "types/onboarding";
import Step from "./Step";

const Flow: React.FC = () => {
  const { data: taxRefundAdvanceApplicationStatus } =
    getTaxRefundAdvanceApplicationStatus();
  const { data: userProfile } = getUserProfile();

  if (!taxRefundAdvanceApplicationStatus) return null;

  let partnerSlug = userProfile?.partnerSlug;
  if (
    taxRefundAdvanceApplicationStatus.currentTaskName ===
    OnboardingTaskName.bankLinking
  ) {
    // Specifically we want to show MSUFCU partner customizations before a user links their bank; however we don't want to continue to show them if a user links a different account
    // TODO: Consider consolidating into something like `uiCustomizationSlug`
    partnerSlug ||= userProfile?.referralSlug;
  }

  return (
    <ProductOnboardingFlow
      tasks={taxRefundAdvanceApplicationStatus.tasks}
      productName={ProductName.taxRefundAdvance}
      partnerSlug={partnerSlug}
      withAuth
    >
      {({ showInfo }) => <Step showInfo={showInfo} partnerSlug={partnerSlug} />}
    </ProductOnboardingFlow>
  );
};

export default Flow;
